import {
    END_POINT,
    EmprunteurStatut,
    IAssureResume,
    IRenouvellement,
    IndicateurFumeur,
    IndicateurResidentCanadien,
    ParcoursAssurance,
    Sexe
} from './useRenouvellementApi';
import { getUserMockedFromUrlParams } from '../../../../utils';
import { mockInstance, withDelay } from '../../../../api';

import { PageInitiale } from '../useSessionApi/useSessionApi';

const listeAssureEmprunteurUnique: Array<IAssureResume> = [
    {
        prenom: 'Guy',
        nom: 'Mock',
        codeSexe: Sexe.MASCULIN,
        age: 45,
        indicateurFumeur: IndicateurFumeur.NON,
        indicateurResidentCanadien: IndicateurResidentCanadien.OUI,
        pctCouvertureAssuranceVie: 100.0,
        pctCouvertureAssuranceInvalidite: 100.0,
        indicateurEligibiliteAssuranceVie: false,
        indicateurEligibiliteAssuranceInvalidite: false,
        questionsAssurabilites: [
            {
                question:
                    'Au cours des <strong>10&nbsp;dernières années</strong>, chez Desjardins Assurances ou ailleurs, avez-vous présenté une <strong>demande d’assurance</strong> vie, invalidité ou maladies graves <strong>qui a été refusée</strong>?',
                reponse: 'Non',
                titreModale: null,
                lienModale: null
            },
            {
                question:
                    'Dans l’ensemble des caisses Desjardins et centres Desjardins Entreprises, avez-vous d’autres prêts ou marges assurés par l’un des produits suivants&nbsp;:',
                reponse: 'Oui',
                puces: [
                    'Assurance prêt',
                    'Assurance prêt&nbsp;&#8211; marge Atout',
                    'Assurance marge de crédit'
                ],
                titreModale: null,
                lienModale: null
            },
            {
                question:
                    'Au cours des <strong>5&nbsp;dernières années</strong>, avez-vous consulté ou été suivi par un professionnel de la santé, reçu un traitement ou pris des médicaments pour au moins un des troubles de la santé suivants&nbsp;:',
                reponse: 'Non',
                puces: [
                    'Dépression, anxiété, troubles d’adaptation, épuisement professionnel (burnout) ou autres troubles psychologiques',
                    'Troubles du dos, du cou ou de la colonne vertébrale<br/>exemple&nbsp;: entorse lombaire, fracture cervicale, hernie discale',
                    'Hypertension artérielle (haute pression)',
                    'Diabète',
                    'Troubles respiratoires chroniques excluant l’asthme<br/>exemple&nbsp;: bronchite chronique, apnée du sommeil, emphysème',
                    'Cancers ou tumeurs malignes',
                    'Maladies cardiaques ou troubles des vaisseaux sanguins<br/>exemple&nbsp;: accident vasculaire cérébral (AVC), accident ischémique transitoire, anévrisme',
                    'Colites ulcéreuses ou maladie de Crohn',
                    'Troubles cérébraux ou neurologiques<br/>exemple&nbsp;: paralysies, épilepsie, sclérose en plaques, tunnel carpien, douleur sciatique',
                    'Fibromyalgie ou fatigue chronique',
                    'Hépatite',
                    'Troubles des reins',
                    'Dépendance à l’alcool ou aux drogues',
                    'Sida ou VIH'
                ],
                titreModale: 'Troubles de la santé',
                lienModale: 'Voir les troubles de la santé'
            }
        ]
    }
];

const listeAssureCoemprunteurs: Array<IAssureResume> = [
    {
        prenom: 'MARTINE',
        nom: 'Mocked',
        codeSexe: Sexe.FEMININ,
        age: 34,
        indicateurFumeur: IndicateurFumeur.NON,
        pctCouvertureAssuranceVie: 100.0,
        pctCouvertureAssuranceInvalidite: 100.0,
        indicateurEligibiliteAssuranceVie: true,
        indicateurEligibiliteAssuranceInvalidite: true
    },
    {
        prenom: 'GUY',
        nom: 'Mocked',
        codeSexe: Sexe.MASCULIN,
        age: 32,
        indicateurFumeur: IndicateurFumeur.NON,
        pctCouvertureAssuranceVie: 10.0,
        pctCouvertureAssuranceInvalidite: 0.0,
        indicateurEligibiliteAssuranceVie: true,
        indicateurEligibiliteAssuranceInvalidite: true
    }
];

// Export this object for BOTH : mock and testing
export const dataCoEmprunteur1: IRenouvellement = {
    pageInitiale: PageInitiale.ACCUEIL,
    codeAvis: null,
    pretAdmissibleAssurance: false,
    montantTotalInteretRetard: 0,
    emprunteurs: [
        {
            id: 28371,
            prenom: 'MARTINE',
            nom: 'Mocked',
            courriel: 'testmock2@mock.com',
            sexe: '2',
            telephone: '5147774444',
            poste: '',
            cellulaire: '',
            statut: EmprunteurStatut.ACCUEIL,
            dateAcceptation: '20210129',
            connecte: false,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: true
        },
        {
            id: 28093,
            prenom: 'GUY',
            nom: 'Mocked',
            courriel: 'testmock@mock.com',
            sexe: '1',
            telephone: '5147774444',
            poste: '',
            cellulaire: '5140001234',
            statut: EmprunteurStatut.CONFIRMEE,
            dateAcceptation: null,
            connecte: true,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: true
        }
    ],
    assures: listeAssureCoemprunteurs
};

// Export for testing
export const dataCoEmprunteur2: IRenouvellement = {
    pageInitiale: PageInitiale.ACCUEIL,
    codeAvis: null,
    pretAdmissibleAssurance: false,
    parcoursAssurance: null,
    montantTotalInteretRetard: 0,
    emprunteurs: [
        {
            id: 28371,
            prenom: 'MARTINE',
            nom: 'Mocked',
            courriel: 'testmock2@mock.com',
            sexe: '2',
            telephone: '5147774444',
            poste: '',
            cellulaire: '',
            statut: EmprunteurStatut.CONFIRMEE,
            dateAcceptation: null,
            connecte: true,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: false
        },
        {
            id: 28093,
            prenom: 'GUY',
            nom: 'Mocked',
            courriel: 'testmock@mock.com',
            sexe: '1',
            telephone: '5147774444',
            poste: '',
            cellulaire: '5140001234',
            statut: EmprunteurStatut.CONFIRMEE,
            dateAcceptation: '20210129',
            connecte: false,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: false
        }
    ],
    assures: listeAssureCoemprunteurs
};

// Export for testing
export const dataEmprunteurUnique: IRenouvellement = {
    pageInitiale: PageInitiale.ACCUEIL,
    codeAvis: null,
    pretAdmissibleAssurance: false,
    parcoursAssurance: null,
    montantTotalInteretRetard: 0,
    emprunteurs: [
        {
            id: 28371,
            prenom: 'UNIQUE',
            nom: 'Mocked',
            courriel: 'testmock@mock.com',
            sexe: '2',
            telephone: '5140001234',
            poste: '',
            cellulaire: '',
            statut: EmprunteurStatut.ACCUEIL,
            dateAcceptation: '20210129',
            connecte: true,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: false
        }
    ]
};

// Export for testing
export const dataEmprunteurUniqueAjoutAssuranceAdmissibleVieEtInvaliditeParcours1: IRenouvellement =
    {
        ...dataEmprunteurUnique,
        pretAdmissibleAssurance: true,
        parcoursAssurance: ParcoursAssurance.PARCOURS_1,
        assures: listeAssureEmprunteurUnique,
        emprunteurs: [
            {
                ...dataEmprunteurUnique.emprunteurs[0],
                isAjoutAssurance: true
            }
        ]
    };

export const dataEmprunteurUniqueAjoutAssuranceAdmissibleVieParcours1: IRenouvellement =
    {
        ...dataEmprunteurUnique,
        pretAdmissibleAssurance: true,
        parcoursAssurance: ParcoursAssurance.PARCOURS_1,
        assures: listeAssureEmprunteurUnique,
        emprunteurs: [
            {
                ...dataEmprunteurUnique.emprunteurs[0],
                admissibleAssuranceInvalidite: false,
                isAjoutAssurance: true
            }
        ]
    };

export const dataEmprunteurUniqueAjoutAssuranceAdmissibleVieEtInvaliditeParcours2: IRenouvellement =
    {
        ...dataEmprunteurUnique,
        pretAdmissibleAssurance: true,
        parcoursAssurance: ParcoursAssurance.PARCOURS_2,
        assures: listeAssureEmprunteurUnique,
        emprunteurs: [
            {
                ...dataEmprunteurUnique.emprunteurs[0],
                isAjoutAssurance: true
            }
        ]
    };

export const dataEmprunteurUniqueAjoutAssuranceAdmissibleVieParcours2: IRenouvellement =
    {
        ...dataEmprunteurUnique,
        pretAdmissibleAssurance: true,
        parcoursAssurance: ParcoursAssurance.PARCOURS_2,
        assures: listeAssureEmprunteurUnique,

        emprunteurs: [
            {
                ...dataEmprunteurUnique.emprunteurs[0],
                admissibleAssuranceInvalidite: false,
                isAjoutAssurance: true
            }
        ]
    };

export const dataEmprunteurUniqueAjoutAssuranceAdmissibleVieEtInvaliditeParcours3: IRenouvellement =
    {
        ...dataEmprunteurUnique,
        pretAdmissibleAssurance: true,
        parcoursAssurance: ParcoursAssurance.PARCOURS_3,
        assures: listeAssureEmprunteurUnique,
        emprunteurs: [
            {
                ...dataEmprunteurUnique.emprunteurs[0],
                isAjoutAssurance: true
            }
        ]
    };

export const dataEmprunteurUniqueAjoutAssuranceAdmissibleVieParcours3: IRenouvellement =
    {
        ...dataEmprunteurUnique,
        pretAdmissibleAssurance: true,
        parcoursAssurance: ParcoursAssurance.PARCOURS_3,
        assures: listeAssureEmprunteurUnique,
        emprunteurs: [
            {
                ...dataEmprunteurUnique.emprunteurs[0],
                admissibleAssuranceInvalidite: false,
                isAjoutAssurance: true
            }
        ]
    };

export const dataEmprunteuruniqueSignatureIntegreeAucuneAssurance: IRenouvellement =
    {
        ...dataEmprunteurUnique,
        pretAdmissibleAssurance: false,
        parcoursAssurance: ParcoursAssurance.NON_ADMISSIBLE,
        assures: null,
        emprunteurs: [
            {
                ...dataEmprunteurUnique.emprunteurs[0],
                admissibleAssuranceVie: false,
                admissibleAssuranceInvalidite: false,
                isAjoutAssurance: false
            }
        ]
    };

export const dataEmprunteurUniqueInteretRetard: IRenouvellement = {
    pageInitiale: PageInitiale.ACCUEIL,
    codeAvis: null,
    pretAdmissibleAssurance: false,
    parcoursAssurance: null,
    montantTotalInteretRetard: 1000.83,
    emprunteurs: [
        {
            id: 28371,
            prenom: 'UNIQUE',
            nom: 'Mocked',
            courriel: 'testmock@mock.com',
            sexe: '2',
            telephone: '5140001234',
            poste: '',
            cellulaire: '',
            statut: EmprunteurStatut.ACCUEIL,
            dateAcceptation: '20210129',
            connecte: true,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: false
        }
    ]
};

export const dataCoEmprunteur2InteretRetard: IRenouvellement = {
    pageInitiale: PageInitiale.OFFRE,
    codeAvis: null,
    pretAdmissibleAssurance: false,
    parcoursAssurance: null,
    montantTotalInteretRetard: 1000,
    emprunteurs: [
        {
            id: 28371,
            prenom: 'MARTINE',
            nom: 'Mocked',
            courriel: 'testmock2@mock.com',
            sexe: '2',
            telephone: '5147774444',
            poste: '',
            cellulaire: '',
            statut: EmprunteurStatut.CONFIRMEE,
            dateAcceptation: null,
            connecte: true,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: false
        },
        {
            id: 28093,
            prenom: 'GUY',
            nom: 'Mocked',
            courriel: 'testmock@mock.com',
            sexe: '1',
            telephone: '5147774444',
            poste: '',
            cellulaire: '5140001234',
            statut: EmprunteurStatut.CONFIRMEE,
            dateAcceptation: '20210129',
            connecte: false,
            admissibleAssuranceInvalidite: true,
            admissibleAssuranceVie: true,
            isAjoutAssurance: false
        }
    ],
    assures: listeAssureCoemprunteurs
};

export const dataErreurTarif = {
    errors: [
        {
            type: 'B',
            code: 'CALCUL_OFFRE',
            message:
                "API OffreTaux: Le numeroEngagment n'existe pas ou n'est pas un engagement de type prÃªt hypothÃ©caire.",
            meta: {
                traceId: '3392f81cbd7c695c'
            }
        }
    ]
};

export const dataErreurTarifAucunDetails = {
    errors: null
};

export const dataErreurPaiementEnAttenteDateRappelImminente = {
    errors: [
        {
            type: 'B',
            code: 'PAIEMENT_EN_ATTENTE',
            message: 'Pret en attente de paiement.',
            meta: {
                versionTexte: 'DATE_RAPPEL_IMMINENTE'
            }
        }
    ]
};

export const dataErreurPaiementEnAttenteDateRappelEloignee = {
    errors: [
        {
            type: 'B',
            code: 'PAIEMENT_EN_ATTENTE',
            message: 'Pret en attente de paiement.',
            meta: {
                versionTexte: 'DATE_RAPPEL_ELOIGNEE',
                revenirJourSemaine: 'dimanche'
            }
        }
    ]
};

const defineMockData = (userMockParam: string): any => {
    if (!userMockParam) return dataCoEmprunteur1;
    switch (userMockParam) {
        case 'coemprunteur2':
        case 'coemprunteur2Retard':
        case 'coemprunteur2SignatureIntegree':
        case 'coemprunteur2OntarioSignatureIntegree':
            return dataCoEmprunteur2;
        case 'emprunteuruniqueSignatureIntegreeDejaAssure':
        case 'emprunteuruniqueontario':
        case 'emprunteuruniqueontarioSignatureIntegree':
            return dataEmprunteurUnique;
        case 'emprunteuruniqueHorsParcoursModaliteAucuneAssurance':
        case 'emprunteuruniqueSignatureIntegreeAucuneAssurance':
            return dataEmprunteuruniqueSignatureIntegreeAucuneAssurance;
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieParcours1':
            return dataEmprunteurUniqueAjoutAssuranceAdmissibleVieParcours1;
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieEtInvaliditeParcours1':
            return dataEmprunteurUniqueAjoutAssuranceAdmissibleVieEtInvaliditeParcours1;
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieParcours2':
            return dataEmprunteurUniqueAjoutAssuranceAdmissibleVieParcours2;
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieEtInvaliditeParcours2':
            return dataEmprunteurUniqueAjoutAssuranceAdmissibleVieEtInvaliditeParcours2;
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieParcours3':
            return dataEmprunteurUniqueAjoutAssuranceAdmissibleVieParcours3;
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieEtInvaliditeParcours3':
            return dataEmprunteurUniqueAjoutAssuranceAdmissibleVieEtInvaliditeParcours3;
        case 'emprunteuruniqueInteretRetard':
            return dataEmprunteurUniqueInteretRetard;
        case 'coemprunteur2InteretRetard':
            return dataCoEmprunteur2InteretRetard;
        case 'erreurTarif':
            return dataErreurTarif;
        case 'erreurTarifAucunDetails':
            return dataErreurTarifAucunDetails;
        case 'erreurPaiementEnAttenteDateRappelImminente':
            return dataErreurPaiementEnAttenteDateRappelImminente;
        case 'erreurPaiementEnAttenteDateRappelEloignee':
            return dataErreurPaiementEnAttenteDateRappelEloignee;
        default:
            return dataCoEmprunteur1;
    }
};

const defineMockStatus = (userMockParam: string): number => {
    if (!userMockParam) return 200;
    switch (userMockParam) {
        case 'erreurTarif':
        case 'erreurTarifAucunDetails':
        case 'erreurPaiementEnAttenteDateRappelImminente':
        case 'erreurPaiementEnAttenteDateRappelEloignee':
            return 500;
        default:
            return 200;
    }
};

export const useRenouvellementApiMock = (): any => {
    const userMockParam = getUserMockedFromUrlParams();

    mockInstance
        .onGet(END_POINT)
        .reply(
            withDelay(
                [
                    defineMockStatus(userMockParam),
                    defineMockData(userMockParam)
                ],
                400
            )
        );
};
